/* eslint-disable react/jsx-props-no-spreading */
// eslint-disable-next-line no-redeclare, @typescript-eslint/no-redeclare
import { Button, Center, Loader, Text } from '@mantine/core';
import { FC, useState } from 'react';
import { i18n } from '@lingui/core';
import { closeAllModals, openModal } from '@mantine/modals';
import { EventCustomerSelect, GeneralCustomerSelect } from '../../Atoms/inputs/CustomerSelect';
import { DocumentS } from '../../Templates/Documents/DocumentS';
import { ToastS } from '../../Service/ToastS';

interface Props {
  documentId: number;
  initialCustomerId: string;
  eventParticipationsContext?: unknown;
  onChange: (customerId: number) => void;
}

export const openChangeCustomerModal = (props: Props) =>
  openModal({
    size: 'sm',
    title: (
      <Text weight="bolder" size="xl" sx={{ lineHeight: 1.2 }}>
        Kunde vom Dokument ändern
      </Text>
    ),
    closeOnEscape: true,
    transition: 'slide-down',
    children: <DocumentChangeCustomerModal {...props} />,
  });

const DocumentChangeCustomerModal: FC<Props> = ({
  documentId,
  onChange,
  initialCustomerId,
  eventParticipationsContext,
}) => {
  const [loading, setLoading] = useState(false);
  const [customerId, setCustomerId] = useState(initialCustomerId);

  const onClick = async () => {
    setLoading(true);

    const resJSON = await DocumentS.patchDocument(documentId, { customerId: Number(customerId) });
    setLoading(false);
    if (resJSON) {
      onChange(Number(customerId));
      closeAllModals();
    } else {
      ToastS.generalError();
    }
  };

  return (
    <>
      <Text mb="md">Wähle den Kunden, der für dieses Dokument verwendet werden soll.</Text>
      {JSON.stringify(eventParticipationsContext) !== '{}' ? (
        <EventCustomerSelect
          disabled={loading}
          eventParticipationContext={eventParticipationsContext}
          initialValue={initialCustomerId}
          onChange={(newCustomerId) => newCustomerId && setCustomerId(newCustomerId)}
        />
      ) : (
        <GeneralCustomerSelect
          disabled={loading}
          initialValue={initialCustomerId}
          onChange={(newCustomerId) => newCustomerId && setCustomerId(newCustomerId)}
        />
      )}
      <Center>
        <Button
          mt={30}
          mb="sm"
          type="submit"
          disabled={loading || initialCustomerId === customerId}
          onClick={onClick}
          leftIcon={loading && <Loader size="xs" />}
          sx={{ width: 250 }}
        >
          {i18n._('actions.save')}
        </Button>
      </Center>
    </>
  );
};

export default DocumentChangeCustomerModal;
